import React from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { RiArrowDropUpLine, RiArrowDropDownLine } from "react-icons/ri";

const FilterSidebar = ({
  subjectSearch,
  setSubjectSearch,
  searchCourseData,
  offset,
  multiFilter,
  loading,
  onSelectFilter,
  handleCollapseFilter,
  clearFilter,
  styles,
}) => (
  <>
    {/*
    <div className="d-flex bg-white rounded-1 py-1 px-2 mb-4">
      <input
        type="search"
        className="form-control fs_12 border-0 form_control_focus_box_shadow_none"
        placeholder="Search Subject"
        aria-label="Username"
        aria-describedby="basic-addon1"
        value={subjectSearch}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            searchCourseData(e.target.value, offset);
          }
        }}
        onChange={(e) => setSubjectSearch(e.target.value, 6)}
      />
      <AiOutlineSearch
        className={`${styles.searhIcon}`}
        onClick={() => searchCourseData(subjectSearch, 0)}
      />
    </div>
    */}
    {/* City Checkbox Options */}
    {loading?.filterLoading ? (
      [1, 2, 3]?.map((item, index) => {
        return (
          <p key={index} className="card-text placeholder-glow mb-5 ">
            <span className="placeholder col-10 d-block mb-3"></span>
            <span className="d-block mb-2">
              <span className="placeholder col-1  me-2"></span>
              <span className="placeholder col-4  "></span>
            </span>
            <span className="d-block mb-2">
              <span className="placeholder col-1  me-2"></span>
              <span className="placeholder col-4  "></span>
            </span>
            <span className="d-block mb-2">
              <span className="placeholder col-1  me-2"></span>
              <span className="placeholder col-4  "></span>
            </span>
          </p>
        );
      })
    ) : multiFilter?.length ? (
      multiFilter?.map((item, index, array) => {
        return (
          <div className="mb-3" key={index}>
            <div className="d-flex justify-content-between">
              <label className="form-label primary_text_color fw-bold " style={{ fontSize: "18px" }}>
                {item?.filterHeader}
              </label>
              {item?.isOpen ? (
                <RiArrowDropUpLine
                  style={{ cursor: "pointer" }}
                  className="primary_text_color"
                  onClick={() => handleCollapseFilter(index, false)}
                  size={30}
                />
              ) : (
                <RiArrowDropDownLine
                  style={{ cursor: "pointer" }}
                  className="primary_text_color"
                  onClick={() => handleCollapseFilter(index, true)}
                  size={30}
                />
              )}
            </div>
            {item?.isOpen &&
              item?.filterOptions?.map((innerItem, innerIndex) => {
                return (
                  <div className="form-check" key={innerItem?.id}>
                    <input
                      checked={innerItem?.checked}
                      name={item?.filterHeader}
                      value={innerItem?.id}
                      onChange={(e) =>
                        onSelectFilter(
                          e,
                          index,
                          innerIndex,
                          item?.filterHeader,
                          innerItem?.name
                        )
                      }
                      className="form-check-input"
                      type="radio"
                      id={innerItem?.id}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="cityCheckbox1"
                      style={{ fontSize: "13px" }}
                    >
                      {innerItem?.name === "Home" ? "Onsite" : innerItem?.name}
                    </label>
                  </div>
                );
              })}
            {item?.filterOptions?.some((item) => item?.checked) ? (
              <u>
                <p
                  style={{ color: "#0000ff96" }}
                  className="pt-1 fs_12 cursor_pointer"
                  onClick={() => {
                    clearFilter(item?.filterHeader);
                  }}
                >
                  clear filter
                </p>
              </u>
            ) : (
              ""
            )}
            {array?.length - 1 !== index && <hr />}
          </div>
        );
      })
    ) : (
      <p className="d-flex justify-content-center align-items-center fs_12 vh-100">
        No record found.
      </p>
    )}
  </>
);

export default FilterSidebar;
